/**
 * 自动播放 tooltip  mixin
 */
export default {
  data() {
      return {
          echartsToolTipAutoPlay: true,
          echartsToolTipAutoPlayInterval: 2000,
          echartsToolTipIndex: 0,
          echartsToolTipLen: 0,
          timer: null
      }
  },
  methods: {
      /**
       * 开启自动播放
       * @param {object} options
       * {
       *  echartsToolTipLen: {number} 轮播总数
       *  seriesIndex: {number} 轮播 series 索引
       * }
       */
      echartsAutoSwitchTooltip: function(options) {
          const {
              echartsToolTipLen,
              echartsToolTipAutoPlayInterval = 2000,
              seriesIndex = 0,
              isNCP = false,
              lineColor = '#fff',
              lineWidth = 1
          } = options
          this.echartsToolTipIndex = 0
          this.echartsToolTipLen = 0
          this.echartsInstance.setOption({
              tooltip: {
                  axisPointer: {
                      type: 'line',
                      lineStyle: {
                          color: lineColor,
                          width: lineWidth
                      }
                  }
              }
          })
          this.echartsInstance.dispatchAction({ type: 'hideTip' })
          clearInterval(this.timer)

          this.echartsToolTipLen = echartsToolTipLen
          this.echartsToolTipAutoPlayInterval = echartsToolTipAutoPlayInterval

          /**
           * 鼠标进入停止自动播放
           */
          this.echartsInstance.on('mouseover', (params) => {
              if (this.echartsToolTipAutoPlay) {
                  this.echartsToolTipAutoPlay = false
                  if (!isNCP) {
                      this.echartsInstance.setOption({
                          tooltip: { triggerOn: 'mousemove' }
                      })
                  }
                  // 取消 echarts 前一个提示框
                  this.echartsInstance.dispatchAction({
                      type: 'hideTip',
                      seriesIndex: seriesIndex,
                      dataIndex: this.echartsToolTipIndex - 1
                  })
                  // 取消 echarts 前一个高亮
                  this.echartsInstance.dispatchAction({
                      type: 'downplay',
                      seriesIndex: 0,
                      dataIndex: this.echartsToolTipIndex - 1
                  })
                  // 设置 echarts 高亮
                  this.echartsInstance.dispatchAction({
                      type: 'highlight',
                      seriesIndex: 0,
                      dataIndex: params.dataIndex
                  })
              }
          })

          /**
           * 鼠标移除开始自动播放
           */
          this.echartsInstance.on('mouseout', (params) => {
              if (!this.echartsToolTipAutoPlay) {
                  this.echartsToolTipAutoPlay = true
                  if (!isNCP) {
                      this.echartsInstance.setOption({
                          tooltip: { triggerOn: 'none' }
                      })
                  }
                  // 取消 echarts 提示框
                  this.echartsInstance.dispatchAction({
                      type: 'hideTip',
                      seriesIndex: seriesIndex,
                      dataIndex: params.dataIndex
                  })
                  // 取消 echarts 前一个高亮
                  this.echartsInstance.dispatchAction({
                      type: 'downplay',
                      seriesIndex: 0,
                      dataIndex: params.dataIndex
                  })
              }
          })

          /**
           * 在固定的间隔内触发
           */
          this.timer = setInterval(() => {
              if (this.echartsToolTipAutoPlay) {
                  if (this.echartsToolTipIndex >= this.echartsToolTipLen) {
                      this.echartsToolTipIndex = 0
                  }
                  // 打开 echarts 提示框
                  this.echartsInstance.dispatchAction({
                      type: 'showTip',
                      seriesIndex: seriesIndex,
                      dataIndex: this.echartsToolTipIndex
                  })
                  // 取消 echarts 前一个高亮
                  this.echartsInstance.dispatchAction({
                      type: 'downplay',
                      seriesIndex: 0,
                      dataIndex: !this.echartsToolTipIndex
                          ? this.echartsToolTipLen - 1
                          : this.echartsToolTipIndex - 1
                  })
                  // 设置 echarts 高亮
                  this.echartsInstance.dispatchAction({
                      type: 'highlight',
                      seriesIndex: 0,
                      dataIndex: this.echartsToolTipIndex
                  })
                  this.echartsToolTipIndex = this.echartsToolTipIndex + 1
              }
          }, this.echartsToolTipAutoPlayInterval)
      }
  }
}
